// extracted by mini-css-extract-plugin
export default {"div":"news_div__sltC+"};